import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner, Label, Input, Button } from 'reactstrap'
import TableContainer from '../../Components/Common/TableContainerReactTable';
import useObtenerRendicionesFondos from '../../Components/Hooks/useObtenerRendicionesFondos';
import useCreateRendicionFondos from '../../Components/Hooks/useCreateRendicionFondos';
import ModalCrearRendicionFondos from '../../Components/modals/ModalCrearRendicionFondos';
import ModalLeerRendicionFondos from '../../Components/modals/ModalLeerRendicionFondos';
import ModalModificarRendicionFondos from '../../Components/modals/ModalModificarRendicionFondos';

const RendicionesFondos = () => {

    const [limit, setLimit] = useState(100);
    const [selectedRendicion, setSelectedRendicion] = useState('');
    const [refresh, setRefresh] = useState(0);
    const { rendiciones, loading, error } = useObtenerRendicionesFondos(limit, refresh);
    const [modalCrearOpen, setModalCrearOpen] = useState(false);
    const [modalLeerOpen, setModalLeerOpen] = useState(false);
    const [modalModificarOpen, setModalModificarOpen] = useState(false);
    const { createRendicion, loading: createLoading, error: createError } = useCreateRendicionFondos();

    const formatDate = (date) => {
        if (!date) return '';
        const _date = new Date(date)
        const year = _date.getFullYear();
        const month = String(_date.getMonth() + 1).padStart(2, '0');
        const day = String(_date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        document.title = "Rendiciones de Fondos | Siga ERP";
    }, []);

    const columns = useMemo(
        () => [
            {
                header: "Tipo Folio",
                accessorKey: "TIPFOL",
                enableColumnFilter: false,
            },
            {
                header: "N° Folio",
                accessorKey: "NUMFOL",
                enableColumnFilter: false,
            },
            {
                header: "Fecha Movimiento",
                accessorKey: "FECMOV",
                enableColumnFilter: false,
                cell: ({ getValue }) => formatDate(getValue()),
            },
            {
                header: "Cliente Proveedor",
                accessorKey: "CLIPRO",
                enableColumnFilter: false,
            },
            {
                header: "Valor Entregado",
                accessorKey: "VALENT",
                enableColumnFilter: false,
                cell: ({ getValue }) => getValue() ? getValue().toLocaleString() : '',
            },
            {
                header: "Valor Rendición",
                accessorKey: "VALREN",
                enableColumnFilter: false,
                cell: ({ getValue }) => getValue() ? getValue().toLocaleString() : '',
            },
            {
                header: "Descripción",
                accessorKey: "DESCRI",
                enableColumnFilter: false,
            },
            {
                header: "Usuario Creación",
                accessorKey: "USUCRE",
                enableColumnFilter: false,
            },
            {
                header: "Fecha Creación",
                accessorKey: "FECCRE",
                enableColumnFilter: false,
                cell: ({ getValue }) => formatDate(getValue()),
            },
        ],
        []
    );

    const handleCellClick = (cellInfo) => {
        console.log('Celda clickeada:', cellInfo);
        console.log('Columna:', cellInfo.columnId);
        console.log('Valor:', cellInfo.value);
        console.log('Datos completos de la fila:', cellInfo.rowData);
        setSelectedRendicion(`${cellInfo.rowData.TIPFOL}-${cellInfo.rowData.NUMFOL}`);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader className="d-flex justify-content-between align-items-center">
                                    <h5 className="card-title mb-0">Rendiciones de Fondos</h5>
                                    <div className="mt-0">
                                        <Input
                                            type="text"
                                            value={selectedRendicion}
                                            onChange={(e) => setSelectedRendicion(e.target.value)}
                                            style={{ width: '250px' }}
                                        />
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <Button color="info" className="me-2" onClick={() => { if (selectedRendicion) setModalLeerOpen(true); }} disabled={!selectedRendicion}>
                                            <i className="ri-eye-line me-1"></i>Leer
                                        </Button>
                                        <Button color="warning" className="me-2" onClick={() => { if (selectedRendicion) setModalModificarOpen(true) }} disabled={!selectedRendicion}>
                                            <i className="ri-edit-line me-1"></i>Modificar
                                        </Button>
                                        <Button color="primary" className="me-2" onClick={() => setModalCrearOpen(true)} disabled={createLoading}>
                                            <i className="ri-add-line me-1"></i>Crear
                                        </Button>
                                        <Label className="form-label mb-0 me-2">Límite</Label>
                                        <div className="mt-0">
                                            <Input
                                                type="number"
                                                min={1}
                                                value={limit}
                                                onChange={(e) => setLimit(e.target.value)}
                                                style={{ width: '100px' }}
                                            />
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    {error ? <div className="alert alert-danger">{error}</div> : loading ? <div className="text-center"><Spinner animation="border" variant="primary" /></div> : <TableContainer
                                        columns={(columns || [])}
                                        data={rendiciones || []}
                                        customPageSize={15}
                                        isGlobalFilter={true}
                                        SearchPlaceholder='Buscar...'
                                        onCellClick={handleCellClick}
                                    />}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ModalCrearRendicionFondos
                isOpen={modalCrearOpen}
                toggle={() => setModalCrearOpen(false)}
                onSave={async (formData) => {
                    const result = await createRendicion(formData);
                    console.log('Resultado de la creación de rendición:', result);
                    if (result.success) {
                        alert('Rendición creada exitosamente');
                        setModalCrearOpen(false);
                        setRefresh(prev => prev + 1); // Refresh the table
                    } else {
                        alert('Error al crear rendición: ' + result.error);
                    }
                }}
            />
            <ModalLeerRendicionFondos
                isOpen={modalLeerOpen}
                toggle={() => setModalLeerOpen(false)}
                selectedRendicion={selectedRendicion}
            />
            <ModalModificarRendicionFondos
                isOpen={modalModificarOpen}
                toggle={() => setModalModificarOpen(false)}
                onSave={() => {
                    setRefresh(prev => prev + 1); // Refresh the table
                }}
                selectedRendicion={selectedRendicion}
            />
        </React.Fragment>
    )
}

export default RendicionesFondos;